let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9f4oR"), load("513ba")]).then(() => parcelRequire('5MyoV'));